import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-dtn209',
  template: `
    <p>
      dtn209 works!
    </p>
  `,
  styles: [
  ]
})
export class Dtn209Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
